import DirectDocumentEditor from "./DirectDocumentEditor";
import { contractStudentFieldIds, resolveContractStudentValues } from "./contractStudentValues";

export const enrollmentDateFieldIds = new Set([
  "initial_enrollment_date",
  "primary_enrollment_date",
  "secondary_enrollment_date",
]);

const hiddenSolicitudFieldIds = new Set([
  ...contractStudentFieldIds,
  ...enrollmentDateFieldIds,
]);

export function resolveEnrollmentDateValues(values) {
  return {
    ...values,
    initial_enrollment_date: "",
    primary_enrollment_date: "",
    secondary_enrollment_date: "",
  };
}

export function resolveSolicitudValues(values) {
  return resolveEnrollmentDateValues(resolveContractStudentValues(values));
}

export default function SolicitudInscripcion() {
  return (
    <DirectDocumentEditor
      document="solicitud"
      downloadAsA4
      hiddenFieldIds={hiddenSolicitudFieldIds}
      resolveDocumentValues={resolveSolicitudValues}
    />
  );
}
